import { Paper } from "@mui/material"

export default function JoinVibioCard({ username }) {

    return (
        <Paper
            elevation={4}
            sx={{
                m: '.8rem 0',
                p: 0,
                display: 'inline-block',
                borderRadius: '40px',
            }}
        >
            <p style={{
                padding: '0 1rem',
                margin: '.2rem 0',
                alignSelf: 'center',
                fontSize: '1rem',
                fontWeight: 500,
                fontFamily: 'Catamaran',
            }}>
                <a
                    href='https://vibio.co'
                    target='_blank'
                    style={{ textDecoration: 'none', color: "#000" }}>
                    Join <b>{username}</b> on Vibio
                </a>
            </p>
        </Paper>
    )
}
